import {
  facultyProfilePermissions,
  unitPermissions,
} from "SuperAdmin/Config/Permissions";
import { createRole } from "SuperAdmin/Services/Role";
import { Form, message } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FormCreate from "./Components/Form/Form";
import styles from "./RoleCreate.module.scss";
const RoleCreate = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const type = Form.useWatch("type", form);
  const unitPermission = Form.useWatch("unit_permissions", form);
  const institution = Form.useWatch("institution", form);
  const facultyProfilePermission = Form.useWatch(
    "faculty_profile_permission",
    form
  );
  const managementScopeID = Form.useWatch("management_scope_id", form);
  const managementScopeName = Form.useWatch("management_scope_name", form);
  useEffect(() => {
    form.setFieldsValue({
      type: 1,
      unit_permissions: [unitPermissions[0].value],
      faculty_profile_permission: [facultyProfilePermissions[0].value],
    });
  }, []);
  const onFinishForm = () => {
    const payload = {
      type: type,
      management_scope_id: managementScopeID,
      management_scope_name: managementScopeName,
      permissions: [...facultyProfilePermission, ...unitPermission],
    };
    createRole(payload, (res) => {
      if (res.status == "OK") {
        setTimeout(() => {
          message.success("Create role successfully!");
        }, 1000);
        navigate("/super-admin/roles");
      }
    });
  };
  return (
    <div className={styles["create-role"]}>
      <FormCreate
        form={form}
        type={type}
        onFinishForm={onFinishForm}
        institution={institution}
      />
    </div>
  );
};

export default RoleCreate;
